module.exports = __webpack_public_path__ + "static/media/LoneSurvivor.2076d69d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Motivation/LoneSurvivor/LoneSurvivor.mp4
// module id = 403
// module chunks = 0